<div class="w-100">
  <form #form>
    <input *ngIf="listId" #input type="text" [ngClass]="[deleteButton ? 'input-list' : 'w-100']" class="{{inputClass}}"
           (focus)="OnFocus()"
           (keypress)="OnKeyPress()"
           (blur)="onBlur($event)"
           (change)="OnChange($event)"
           [placeholder]="placeholder"
           [disabled]="isDisabled"/>
    <button *ngIf="deleteButton" type="reset" class="btn q-btn q-danger btn-list" (click)="OnReset()">
      <i class="fas fa-trash-alt"></i>
    </button>
  </form>
  <small *ngIf="!_isValid && showTextValid" class="q-c-danger w-100">Veuillez sélectionner une valeur valide.</small>
</div>
<datalist [id]="listId">
  <option *ngFor="let data of dataList" [value]="data"></option>
</datalist>
